import { isPdbId, isJobId ,isAFId} from "./IdUtils";
import {RootPath} from "./Settings"

export const INFO_URL = RootPath+'infos/info.json';
//export const INFO_URL = '/infos/info.json';
  // "homepage": "http://192.168.3.4/castpdev",
//   const localIpAddress = 'http://10.8.169.96';
//   const localIpAddress = 'http://10.8.168.172';
//   const localIpAddress = 'http://sts.bioe.uic.edu';
//   const localIpAddress = 'https://cfold.bme.uic.edu/castpfold/';
const pdbBaseUrl = (pdb) =>{
    // const localIpAddress = 'http://10.8.171.30/castpfold/';
    const localIpAddress = 'https://cfold.bme.uic.edu/castpfold';
    // const localIpAddress = 'http://sts.bioe.uic.edu/castpfold/';

    if (isPdbId(pdb)) {
        // console.log( isPdbId);
        // console.log( localIpAddress + '/data/pdb/' + pdb.substring(1, 3) + '/' + pdb + '/');
        return localIpAddress + '/data/pdb/' + pdb.substring(1, 3) + '/' + pdb + '/';
    } else if (isJobId(pdb)) {
        return localIpAddress + '/data/tmppdb/' + pdb + '/';
    } else if (isAFId(pdb)) {
        // console.log( localIpAddress + '/data/AF_db/' + pdb.substring(3, 6) + '/' + pdb + '/');
        return localIpAddress + '/data/AF_db/' + pdb.substring(3, 6) + '/' + pdb + '/';
    }
}



const pdbTmpUrl = (pdb) =>{
    return pdbBaseUrl(pdb)+'tmp/';
}

const pdbProcessedUrl = (pdb) =>{
    return pdbBaseUrl(pdb)+'processed/';
}

export function AFmapurl(pdb)  {
    const length = pdb.length; 
    // const localIpAddress = 'http://10.8.171.30/castpfold/';
    const localIpAddress = 'https://cfold.bme.uic.edu/castpfold/';
    // const localIpAddress = 'http://sts.bioe.uic.edu/castpfold/';
    if (length === 6){
        return localIpAddress + '/searchmapping/sixmer/' + pdb.substring(3,6) + '/' + pdb.substring(3,6) + '.pathmap.json';
    } else if (length === 10){
        return localIpAddress + '/searchmapping/tenmer/' + pdb.substring(3,6) + '/' + pdb.substring(3,8) + '/' + pdb.substring(3,8) + '.pathmap.json';
    }
}

export function pdbGeneralInfoUrl(pdb) {
    return pdbProcessedUrl(pdb)+pdb+'.basic.json';
}
export function pdbPocSimiUrl(pdb) {
    return pdbProcessedUrl(pdb)+pdb+'.pocsimi.json';
}
// export function pdbPdbFileUrl(pdb) {
//     return pdbBaseUrl(pdb)+pdb+'.pdb';
// }

export function pdbPdbFileUrl(pdb) {
    const baseUrl = pdbBaseUrl(pdb);
    return {
        pdbUrl: baseUrl + pdb + '.pdb',  // URL for PDB file
        cifUrl: baseUrl + pdb + '.cif'   // URL for CIF file
    };
}
export function pdbAssemblyUrl(pdb){
    return pdbProcessedUrl(pdb)+pdb+'.assem.json';
}
export function pdbDownloadUrl(pdb){
    return pdbProcessedUrl(pdb)+pdb+'.zip'
}
export function pdbPocMeasureUrl(pdb){
    return pdbTmpUrl(pdb)+pdb+'.measure.json'
}
export function pdbSeqInfoUrl(pdb){
    return pdbProcessedUrl(pdb)+pdb+'.seq.json'
}
export function pdbFeatInfoUrl(pdb){
    return pdbProcessedUrl(pdb)+pdb+'.feat.json'
}
export function pdbBulbUrl(pdb){
    return pdbTmpUrl(pdb)+pdb+'.bulb.json' 
}
export function pdbZipUrl(pdb){
    return pdbProcessedUrl(pdb)+pdb+'.zip' 
}
export function pdbDFscoreUrl(pdb){
    return pdbProcessedUrl(pdb)+pdb+'_MF_predictions.csv'
}
export function pdb2AF2Url(pdb){
    const localIpAddress = 'https://cfold.bme.uic.edu/castpfold/';
    return localIpAddress + '/pdb_AF2_mapping/' + pdb.substring(1,3) + '/' + pdb + '_mappings.json';   
}


// WEBPACK FOOTER //
// ./src/UrlManager.js